export const TODAY = "TODAY"
export const YESTERDAY = "YESTERDAY"
export const TOMORROW = "TOMORROW"